import { ListRenderItem } from "react-native";
import React, { useCallback, useMemo } from "react";
import { FlatList } from "react-native-gesture-handler";
import { getDateSequenceFormatting } from "../../../common/dateFormat";
import { Symbols } from "./Symbols";
import { graphql, usePaginationFragment } from "react-relay";
import { RoutineOccasionFollowupColumn } from "./RoutineOccasionFollowupColumn";
import { RoutineOccasionFollowupOccasionList_routine$key } from "./__generated__/RoutineOccasionFollowupOccasionList_routine.graphql";

export function RoutineOccasionFollowupOccasionList(props: {
  routine: RoutineOccasionFollowupOccasionList_routine$key;
  width: number;
  itemWidth: number;
  numberOfItems: number;
}) {
  const { data, loadNext, hasNext } = usePaginationFragment(
    graphql`
      fragment RoutineOccasionFollowupOccasionList_routine on Routine
      @refetchable(
        queryName: "RoutineOccasionFollowupOccasionListPaginationQuery"
      ) {
        id
        ...RoutineOccasionFollowupColumn_routine
        occasions(first: $first, after: $after)
          @connection(key: "Routine_occasions") {
          edges {
            node {
              ...RoutineOccasionFollowupColumn_RoutineOccasion
              id
              startAt
            }
          }
        }
      }
    `,
    props.routine
  );

  const occasions = useMemo(() => data.occasions.edges, [data.occasions.edges]);

  const dateFormating = useMemo(() => {
    return getDateSequenceFormatting(occasions.map((occ) => occ.node.startAt));
  }, [occasions]);

  const renderColumn: ListRenderItem<(typeof occasions)[number]> = useCallback(
    ({ item }) => (
      <RoutineOccasionFollowupColumn
        dateFormating={dateFormating}
        itemWidth={props.itemWidth}
        occasion={item.node}
        routine={data}
      />
    ),
    [data, dateFormating, props.itemWidth]
  );

  const onEndReached = useCallback(() => {
    if (hasNext) {
      loadNext(14);
    }
  }, [hasNext, loadNext]);

  return (
    <>
      <FlatList
        extraData={dateFormating}
        style={{
          flex: 1,
          borderTopColor: "#ddd",
          borderTopWidth: 1,
          paddingBottom: 300,
        }}
        contentContainerStyle={{
          paddingLeft:
            (props.width - props.itemWidth * props.numberOfItems) / 2,
        }}
        inverted
        horizontal
        keyExtractor={(item) => item.node.id}
        data={data.occasions?.edges ?? []}
        contentOffset={{ x: 0, y: 0 }}
        showsHorizontalScrollIndicator={false}
        snapToInterval={props.itemWidth}
        decelerationRate="fast"
        onEndReachedThreshold={0.3}
        onEndReached={onEndReached}
        renderItem={renderColumn}
      />
      {occasions.length > 0 ? <Symbols /> : null}
    </>
  );
}
